export default "__VITE_ASSET__$Gi8h25c__"